/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Api from "../../../../services/ServiceApi";
import { isMobile } from "react-device-detect";

const steps = [
  { text: "Depart", time: "10.05" },
  { text: "On Site", time: "10.35" },
  { text: "Accident Point", time: "11.35" },
  { text: "Progressive", time: "-" },
  { text: "Alarm Clear", time: "10.35" },
  { text: "Fixed Problem", time: "11.35" },
  { text: "Request Close Job", time: "-" },
];

export default function status_process({ CurrentSteps }) {
  return (
    <div className="card-step-job overflow-auto" style={{ height: "auto" }}>
      <ul
        className="text-center"
        style={{ width: isMobile ? "1000px" : "auto" }}
      >
        {steps.map((step, index) => (
          <li
            key={`step_job_${index + 1}`}
            className={`small ${index < CurrentSteps ? "active" : ""}`}
            // style={{ width: "150px" }}
          >
            <img
              src={
                index < CurrentSteps
                  ? `${Api.absoluteUrl(
                      `/icon/icon_step_uih/step_${index + 1}.png`
                    )}`
                  : `${Api.absoluteUrl(
                      `/icon/icon_step_uih/step_${index + 1}_gray.png`
                    )}`
              }
            />
            <div className="step-status_dynamic">
              <img
                src={
                  index < CurrentSteps
                    ? `${Api.absoluteUrl("/icon/step_success.svg")}`
                    : `${Api.absoluteUrl(`/icon/step_wait.svg`)}`
                }
              ></img>
            </div>
            <p className="font-thai-r fs-20 my-0">{step.text}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
